import { AnyAction, Reducer } from 'redux';
import { RomEventTypes, RomUpdateAction } from './types';
import { RomEditorState } from './interfaces';
import produce from 'immer';

const romState: RomEditorState = {
    name: '',
    romId: undefined,
    metaData: '{}',
    description: '',
    resource: undefined,
    gameFile: undefined,
    gameFileName: '',
    image: null,
    bannerImage: null
};

const setRomValue = produce(<K extends keyof RomEditorState>(draft: RomEditorState, action: RomUpdateAction<K>) => {
    draft[ action.name ] = action.value;
});

// const createMetaDataList = produce( ( draft: RomState, action: ReturnType<typeof actions.createMetaDataList> ) => {
//     if (typeof draft.metaData !== 'object') {
//         throw new Error('Assertion in reducer failed.');
//     }
//     draft.metaData[ action.key ] = [];
// } );
//
// const addMetaDataItem = produce( ( draft: RomState, action: ReturnType<typeof actions.addMetaDataItem> ) => {
//     if (typeof draft.metaData !== 'object') {
//         throw new Error('Assertion in reducer failed.');
//     }
//     (draft.metaData[ action.key ] as unknown[]).push( action.item );
// } );
//
// const removeMetaDataItem = produce( ( draft: RomState, action: { key: string, id: any } ) => {
//     if (typeof draft.metaData !== 'object') {
//         throw new Error('Assertion in reducer failed.');
//     }
//     draft.metaData[ action.key ] = (draft.metaData[ action.key ] as Array<{ id: unknown }>)
//         .filter( ( item ) => item.id !== action.id );
// } );
//
// const setMetaDataItemValue = produce( ( draft: RomState, action: ReturnType<typeof actions.setMetaDataItemValue> ) => {
//     if (typeof draft.metaData !== 'object') {
//         throw new Error('Assertion in reducer failed.');
//     }
//     draft.metaData[ action.key ] = (draft.metaData[ action.key ] as Array<{ id: unknown }>)
//             .map( item => item.id === action.id ? { ...item, [ action.name ]: action.value } : item )
// } );

export const romReducer: Reducer<RomEditorState> = (state = romState, action: AnyAction) => {
    switch (action.type) {
        case RomEventTypes.SET_ROM_VALUE:
            return setRomValue(state, action as RomUpdateAction<any>);

        case RomEventTypes.SET_ROM:
            // let metaData1 = JSON.parse( action.rom.metaData );
            // if ( typeof metaData1 === 'string' ) {
            //     metaData1 = {};
            // }
            return { 
                ...state, 
                ...action.rom, 
                // metaData: metaData1
            };

        // case RomEventTypes.CREATE_META_DATA_LIST:
        //     return createMetaDataList( state, action as ReturnType<typeof actions.createMetaDataList> );

        // case RomEventTypes.REMOVE_META_DATA_LIST:
        //     let metaData2 = state.metaData;
        //     if ( typeof metaData2 === 'object' ) {
        //         metaData2 = { ...metaData2 };
        //         delete metaData2[ action.key ];
        //     }
        //     return {
        //         ...state,
        //         metaData: metaData2
        //     }

        // case RomEventTypes.CREATE_META_DATA_ITEM:
        //     return addMetaDataItem( state, action as ReturnType<typeof actions.addMetaDataItem> );

        // case RomEventTypes.REMOVE_META_DATA_ITEM:
        //     return removeMetaDataItem( state, action as { type: RomEventTypes.REMOVE_META_DATA_ITEM, key: string, id: any } );

        // case RomEventTypes.UPDATE_META_DATA_ITEM_VALUE:
        //     return setMetaDataItemValue( state, action as ReturnType<typeof actions.setMetaDataItemValue> );

        case RomEventTypes.CLEAR_ROM:
            return romState;

        default:
            return state;
    }
};
